import {
  Filter,
  FilterContent,
  FilterTrigger,
  type FilterContentProps,
} from '@/components/shared/Filter';

import { Link } from '@design-system/Link';
import { ChevronRightIcon } from 'lucide-react';
import { SETTINGS_PATH } from '@/constants/paths';
import { useGetFoodFilterQueryV2 } from '@viome/viome-base/src/usecase/Nutrition/NutritionQuery';
import { useGetInitData } from '@viome/viome-base/src/usecase/Bootup/BootupQuery';
import { EventTracker } from '@/utils';

export type MyFoodsPageFilterSidebarProps = FilterContentProps;

const handleSettingRedirection = () => {
  EventTracker.trackEvent(
    'nutrition',
    'nutrition_myFoods_filter_showVegetarian_updateSettings',
  );
  return SETTINGS_PATH;
};

export const MyFoodsPageFilterSidebar = ({
  onSubmit,
  initialValue = {},
}: MyFoodsPageFilterSidebarProps) => {
  const { data: response, isLoading, isError } = useGetFoodFilterQueryV2();
  const { data: initData } = useGetInitData();

  const filters = response?.[0]?.filter;
  const isVegetarian = initData?.isVegetarian;

  return (
    <Filter>
      <FilterTrigger
        isError={isError}
        isLoading={isLoading}
        initialValue={initialValue}
      />

      <FilterContent
        filters={filters}
        isError={isError}
        onSubmit={onSubmit}
        isLoading={isLoading}
        initialValue={initialValue}
      >
        {isVegetarian && (
          <div className="flex flex-col gap-4">
            <span className="text-secondary typography-h3">
              Showing Vegetarian Foods Only
            </span>
            <Link className="justify-start gap-2" to={handleSettingRedirection()}>
              Update in Settings
              <ChevronRightIcon
                width={24}
                height={24}
                aria-hidden
                className="!size-5"
              />
            </Link>
          </div>
        )}
      </FilterContent>
    </Filter>
  );
};
